import { useEffect, useState, useCallback } from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

export function PWAUpdatePrompt() {
  const [showBanner, setShowBanner] = useState(false);

  const handleUpdate = useCallback(() => {
    navigator.serviceWorker?.getRegistration().then((reg) => {
      if (reg?.waiting) {
        reg.waiting.postMessage({ type: "SKIP_WAITING" });
      }
    });
    // The controllerchange listener in main.tsx will reload
    window.location.reload();
  }, []);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const checkForUpdate = async () => {
      const reg = await navigator.serviceWorker.getRegistration();
      if (!reg) return;

      // If there's already a waiting SW, show banner
      if (reg.waiting) {
        setShowBanner(true);
        return;
      }

      // Listen for new SW installing
      reg.addEventListener("updatefound", () => {
        const newSW = reg.installing;
        if (!newSW) return;
        newSW.addEventListener("statechange", () => {
          if (newSW.state === "installed" && navigator.serviceWorker.controller) {
            setShowBanner(true);
          }
        });
      });

      // Poll for updates every 60s
      const interval = setInterval(() => reg.update(), 60 * 1000);
      return () => clearInterval(interval);
    };

    checkForUpdate();
  }, []);

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] bg-primary text-primary-foreground px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 max-w-sm animate-fade-in">
      <RefreshCw className="w-4 h-4 shrink-0" />
      <span className="text-sm font-medium">A new version is available</span>
      <Button
        size="sm"
        variant="secondary"
        onClick={handleUpdate}
        className="shrink-0"
      >
        Update
      </Button>
    </div>
  );
}
